<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<h1>Copyright Information</h1>
<p><strong>Copyright © JoAnn Aitken (2019)</strong></p>
<p>All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other non-commercial uses permitted by copyright law. For permission requests, write to the publisher.</p>
<p>Any person who commits any unauthorized act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<p><strong>Ordering Information:</strong></p>
<p>Quantity sales: special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the publisher at the address below.</p>
<p><strong>Publisher’s Cataloging-in-Publication data</strong></p>
<p>Aitken, JoAnn</p>
<p>Family Portraits</p>
<p>ISBN 9781643780092 (Paperback)</p>
<p>ISBN 9781643780108 (Hardback)</p>
<p>ISBN 9781645366713 (ePub e-book)</p>
<p>The main category of the book — Fiction / Romance / Contemporary</p>
<p>Library of Congress Control Number: 2019908442</p>
<p>www.austinmacauley.com/us</p>
<p>First Published (2019)</p>
<p>Austin Macauley Publishers LLC</p>
<p>40 Wall Street, 28<sup>th</sup> Floor</p>
<p>New York, NY 10005</p>
<p>USA</p>
<p>mail-usa@austinmacauley.com</p>
<p>+1 (646) 5125767</p>
<p><br/></p>
<div class="pagebreak"></div>
<p>“Jesus, Finn…you fucking my sister on the supper table?” Ronnie leaned in the archway, eating a cookie.</p>
<p>Finn straightened up with a start and quickly pulled himself together. He had been far away, lost in his young wife, transported by her warm breath on his neck and her whispered words of love in his ear.</p>
<p>“What are you doing here? We didn’t expect you until late.”</p>
<p>“I live here, Finn, if you will recall.” Ronnie popped the last bite of cookie into his month and headed for the stairs. “Just came home to change. I won’t be long.” He looked at his little sister who was covered up now and sat with her face hidden against her new husband’s chest.</p>
<p>He felt sorry for his intrusion, albeit unintentional, and said as he started upstairs, “I know you’re married but three weeks. I’ll not say a word.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?cfd7ae7a